import { render, staticRenderFns } from "./Fip.vue?vue&type=template&id=609a6810&"
import script from "./Fip.vue?vue&type=script&lang=js&"
export * from "./Fip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports